import { Stack, Typography } from '@mui/material';
import type { ReactNode } from 'react';

export const GeneralEmptyState = ({
  title,
  description,
  button,
}: {
  title: string;
  description: string;
  button: ReactNode;
}) => {
  return (
    <Stack
      spacing='24px'
      sx={{
        alignItems: 'center',
        marginY: '40px',
      }}
    >
      <Typography variant='h3' align='center'>
        {title}
      </Typography>
      <Typography
        variant='subtitle2'
        align='center'
        sx={{
          maxWidth: '540px',
        }}
      >
        {description}
      </Typography>
      {button}
    </Stack>
  );
};
